<div class="layout">
  <div class="layout__topbar">
    <app-topbar (menuToggle)="toggleSidebar()" />
  </div>
  <div class="layout__body">
    <div class="layout__sidebar" [class.layout__sidebar--collapsed]="sidebarCollapsed">
      <app-sidebar [collapsed]="sidebarCollapsed"/>
    </div>
    <main class="layout__content">
      <router-outlet />
    </main>
  </div>
</div>
